import { render, staticRenderFns } from "./AD.vue?vue&type=template&id=0c897506&"
import script from "./AD.vue?vue&type=script&lang=js&"
export * from "./AD.vue?vue&type=script&lang=js&"
import style0 from "./AD.vue?vue&type=style&index=0&id=0c897506&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports